// 发布端App端
import { createAPI } from '@common'

export default {
  // 发布端App端-查看信息
  getApps: (config) => createAPI('customEncryptApiName-1/0nfejby.bsujdmfbqq0bqqt', 'get', config),
  // 获取小程序配置信息
  getMinProgramSetting:(config) => createAPI('customEncryptApiName-1/0nfejby.bsujdmfbqq0bqqt0bqqmfuDpog', 'get', config),
  // 保存小程序配置信息
  setMinProgramSetting:(config) => createAPI('customEncryptApiName-1/0nfejby.bsujdmfbqq0bqqt0bqqmfu0dpogjh', 'post', config),
  //保存APP端早晚报配置
  postAppsDailyPaperConf: (config) => createAPI('customEncryptApiName-1/0nfejby.bsujdmfbqq0bqqt0ebjmzQbqfsDpog', 'post', config),
  //获取早晚报智能体地址
  getMbdzxAutoLogin: (config) => createAPI('customEncryptApiName-1/0nfejby.bsujdmfbqq0bqqt0nce{yEbjmzVsm', 'get', config),
  // 特殊配置-修改
  postAppsSpecialconf: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfbqq0bqqt0tqfdjbmdpog', 'post', config),
  //智能机器人
  getSmartAIConf: (config) => createAPI('customEncryptApiName-1/0nfejby.bsujdmfbqq0bqqt0hfuTnbsuBJDpog', 'get', config),
  // 参数配置-修改
  postAppsParameterconf: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfbqq0bqqt0qbsbnfufsdpog', 'post', config),
  postSaveSmartAIConf: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfbqq0bqqt0tbwfTnbsuBJDpog', 'post', config),
  // 版本管理-修改
  postAppsVersion: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfbqq0bqqt0wfstjpo', 'post', config),
  // 模板管理-修改
  postAppsTemplateconf: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfbqq0bqqt0ufnqmbufdpog', 'post', config),
  // 全局功能配置-修改
  postAppsGlobalconf: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfbqq0bqqt0hmpcbmdpog', 'post', config),
  // 界面配置-保存
  postAppsUiconf: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfbqq0bqqt0vjdpog', 'post', config),
  //  获取站点列表
  getAppSites: (config) => createAPI('customEncryptApiName-1/0nfejby.bsujdmfbqq0tjuft', 'get', config),
  // 保存空间配置
  postAppsSave: (config) => createAPI('customEncryptApiName-1/0nfejby.bsujdmfbqq0tqbdf0tbwf', 'post', config),
  //查询 空间 详情
  getAppsSpace: (config) => createAPI('customEncryptApiName-1/0nfejby.bsujdmfbqq0tqbdf0efubjm', 'get', config),
//  子空间初始化排序接口
  postInitOrder: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfbqq0tqbdf0jojuPsefs', 'post', config),
  // 基础信息-保存
  postAppsBase: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfbqq0bqqt0cbtf', 'post', config),
  // 检查APP版本信息
  getAppsCheckVersion: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfbqq0bqqt0difdlWfstjpo', 'get', config),
  getDetails: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfbqq0f60efubjmt', 'get', config),
  // 删除版本
  deleteApps: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfbqq0bqqt0efmfuf', 'post', config),
  // 评论内容详情
  getNisDiscussContent: (config) =>
    createAPI('customEncryptApiName-1/0w20ojt0ejtdvtt0dpoufou', 'get', config),
  // 评论内容
  postNisDiscussReply: (config) =>
    createAPI('customEncryptApiName-1/0w20ojt0ejtdvtt0sfqmz', 'post', config),
  // 查看授权清单
  getSitesAuthorization: (config) =>
    createAPI('customEncryptApiName-1/0w20tjuft0bvuipsj{bujpo', 'GET', config),
  // 微信公众号账号列表
  getWeixinAccounts: (config) =>
    createAPI('customEncryptApiName-1/0w20xfjyjo0bddpvout', 'GET', config),
  // 添加账号
  getWeixinAccountsAdd: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfxy0xfjyjo0bddpvout0bee', 'GET', config),
  // 设置流程
  getWeixinAccountsDetail: (config) =>
    createAPI('customEncryptApiName-1/0w20xfjyjo0bddpvout0efubjm', 'GET', config),
  // 保存流程设置
  postWeixinAccountsFlow: (config) =>
    createAPI('customEncryptApiName-1/0w20xfjyjo0bddpvout0gmpx', 'POST', config),
  // 退出授权
  getWeixinAccountsDisable: (config) =>
    createAPI('customEncryptApiName-1/0w20xfjyjo0bddpvout0ejtbcmf', 'GET', config),
  // 删除账号
  deleteWeixinAccounts: (config) =>
    createAPI('customEncryptApiName-1/0w20xfjyjo0bddpvout', 'DELETE', config),
  // 检查状态
  getWeixinAccountsStatus: (config) =>
    createAPI('customEncryptApiName-1/0w20xfjyjo0bddpvout0tubuvt', 'GET', config),
  // 微博账号列表
  getWeiboAccounts: (config) => createAPI('customEncryptApiName-1/0w20xfjcp0bddpvout', 'GET', config),
  // 添加账号
  getWeiboAccountsAdd: (config) =>
    createAPI('customEncryptApiName-1/0w20xfjcp0bddpvout0bee', 'GET', config),
  // 设置流程
  getWeiboAccountsDetail: (config) =>
    createAPI('customEncryptApiName-1/0w20xfjcp0bddpvout0efubjm', 'GET', config),
  // 保存流程设置
  postWeiboAccountsFlow: (config) =>
    createAPI('customEncryptApiName-1/0w20xfjcp0bddpvout0gmpx', 'POST', config),
  // 退出授权
  getWeiboAccountsDisable: (config) =>
    createAPI('customEncryptApiName-1/0w20xfjcp0bddpvout0ejtbcmf', 'GET', config),
  // 删除账号
  deleteWeiboAccounts: (config) =>
    createAPI('customEncryptApiName-1/0w20xfjcp0bddpvout', 'DELETE', config),
  // 检查状态
  getWeiboAccountsStatus: (config) =>
    createAPI('customEncryptApiName-1/0w20xfjcp0bddpvout0tubuvt', 'GET', config),
  // 检查状态
  getWeiboAccountsAddCallback: (config) =>
    createAPI('customEncryptApiName-1/0w20xfjcp0bddpvout0beeDbmmcbdl', 'GET', config),

  // -----------网站端配置api------------------
  // 获取Web发布端配置
  getWebConfigs: (config) => createAPI('customEncryptApiName-1/0w20xfc0dpogjht', 'GET', config),
  // 保存Web发布端基础配置
  postWebConfigsBase: (config) =>
    createAPI('customEncryptApiName-1/0w20xfc0dpogjht0cbtf', 'POST', config),
  // 保存Web发布端顶部元素配置
  postWebConfigsTop: (config) =>
    createAPI('customEncryptApiName-1/0w20xfc0dpogjht0upq', 'POST', config),
  // 保存Web发布端其它配置
  postWebConfigsOther: (config) =>
    createAPI('customEncryptApiName-1/0w20xfc0dpogjht0puifs', 'POST', config),
  // Web发布端-右侧区块——新建
  postSideModules: (config) => createAPI('customEncryptApiName-1/0w20tjef0npevmft', 'POST', config),
  // Web发布端-右侧区块——修改
  putSideModules: (config) => createAPI('customEncryptApiName-1/0w20tjef0npevmft', 'PUT', config),
  // Web发布端-右侧区块——详情
  getSideModules: (config) => createAPI('customEncryptApiName-1/0w20tjef0npevmft', 'GET', config),
  // Web发布端-右侧区块——启用
  postSdeModulesOpen: (config) =>
    createAPI('customEncryptApiName-1/0w20tjef0npevmft0pqfo', 'POST', config),
  // Web发布端-右侧区块——禁用
  postSdeModulesClose: (config) =>
    createAPI('customEncryptApiName-1/0w20tjef0npevmft0dmptf', 'POST', config),
  // Web发布端-右侧区块——删除
  postSdeModulesDelete: (config) =>
    createAPI('customEncryptApiName-1/0w20tjef0npevmft0efmfuf', 'POST', config),

  // -------------------三方账号管理---------------------
  postOtherArticlesFlow: (config) =>
    createAPI('customEncryptApiName-1/0w20puifsBsujdmft0gmpx', 'POST', config),
  getOtherArticlesFlow: (config) =>
    createAPI('customEncryptApiName-1/0w20puifsBsujdmft0gmpx', 'GET', config),
  getOtherAccounts: (config) => createAPI('customEncryptApiName-1/0w20puifs0bddpvout', 'GET', config),
  delOtherAccounts: (config) =>
    createAPI('customEncryptApiName-1/0w20puifs0bddpvout', 'DELETE', config),
  getOtherAccountsQieAdd: (config) =>
    createAPI('customEncryptApiName-1/0w20puifs0bddpvout0rjf0bee', 'GET', config),
  getOtherAccountsDisable: (config) =>
    createAPI('customEncryptApiName-1/0w20puifs0bddpvout0ejtbcmf', 'GET', config),
  getOtherAccountsQieAddCallback: (config) =>
    createAPI('customEncryptApiName-1/0w20puifs0bddpvout0rjf0beeDbmmcbdl', 'GET', config),
  getOtherAccountsBaijiaAdd: (config) =>
    createAPI('customEncryptApiName-1/0w20puifs0bddpvout0cbjkjb0bee', 'GET', config),
  getOtherAccountsBaijiaAddCallback: (config) =>
    createAPI('customEncryptApiName-1/0w20puifs0bddpvout0cbjkjb0beeDbmmcbdl', 'GET', config, {
      neverLoading: true
    }),
  getOtherAccountsDetail: (config) =>
    createAPI('customEncryptApiName-1/0w20puifs0bddpvout0efubjm', 'GET', config),
  getOtherAccountsToutiaoAdd: (config) =>
    createAPI('customEncryptApiName-1/0w20puifs0bddpvout0upvujbp0bee', 'GET', config),
  postOtherAccountsToutiao: (config) =>
    createAPI('customEncryptApiName-1/0w20puifs0bddpvout0upvujbp', 'POST', config),

  // -------------------三方账号管理---------------------
  // 微博账号列表
  getDouyinAccounts: (config) =>
    createAPI('customEncryptApiName-1/0w20epvzjo0bddpvout', 'GET', config),
  // 添加账号
  getDouyinAccountsAdd: (config) =>
    createAPI('customEncryptApiName-1/0w20epvzjo0bddpvout0bee', 'GET', config),
  // 设置流程
  getDouyinAccountsDetail: (config) =>
    createAPI('customEncryptApiName-1/0w20epvzjo0bddpvout0efubjm', 'GET', config),
  // 保存流程设置
  postDouyinAccountsFlow: (config) =>
    createAPI('customEncryptApiName-1/0w20epvzjo0bddpvout0gmpx', 'POST', config),
  // 退出授权
  getDouyinAccountsDisable: (config) =>
    createAPI('customEncryptApiName-1/0w20epvzjo0bddpvout0ejtbcmf', 'GET', config),
  // 删除账号
  deleteDouyinAccounts: (config) =>
    createAPI('customEncryptApiName-1/0w20epvzjo0bddpvout', 'DELETE', config),
  // 检查状态
  getDouyinAccountsStatus: (config) =>
    createAPI('customEncryptApiName-1/0w20epvzjo0bddpvout0tubuvt', 'GET', config),
  // 检查状态
  getDouyinAccountsAddCallback: (config) =>
    createAPI('customEncryptApiName-1/0w20epvzjo0bddpvout0beeDbmmcbdl', 'GET', config),

  // -------------------对接渠道---------------------
  // 读渠道详情
  getOtherChannel: (config) => createAPI('customEncryptApiName-1/0w20puifs0diboofm', 'GET', config),
  // 新建/修改渠道
  postOtherChannel: (config) => createAPI('customEncryptApiName-1/0w20puifs0diboofm', 'POST', config),
  // 删除渠道
  deleteOtherChannel: (config) =>
    createAPI('customEncryptApiName-1/0w20puifs0diboofm', 'DELETE', config),
  // 名称设置
  postChannelConfig: (config) =>
    createAPI('customEncryptApiName-1/w20puifs0diboofm0dpogjh', 'POST', config),
  // -------------------对接渠道结束---------------------
  // 意见反馈-删除意见
  postDeleteFeedback: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfbqq0gffe0efmfuf', 'DELETE', config),
  // 意见反馈详情
  getFeedDetail: (config) => createAPI('customEncryptApiName-1/0nfejby.bsujdmfbqq0gffe0efubjm', 'GET', config),
  // 意见反馈回复
  postFeedReplycontent: (config) => createAPI('customEncryptApiName-1/0nfejby.bsujdmfbqq0gffe0sfqmzdpoufou', 'POST', config),

  // APP设置-年度报告配置- 首次使用生成
  getAnnualReportConfs: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfbqq0bqqt0hfuBoovbmSfqpsuDpog', 'get', config),
  // APP设置-年度报告配置-修改
  postSaveAnnualReportConf: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfbqq0bqqt0tbwfBoovbmSfqpsuDpog', 'post', config),
  // APP设置-年度报告配置-修改
  getResetInterfaceValue: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfbqq0bqqt0sftfuJoufsgbdfWbmvf', 'get', config),
  // APP设置-年度报告预览
  postAnnualReportPreview: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfbqq0bqqt0boovbmSfqpsuQsfwjfx', 'post', config),
  // 小记者人员列表
  postYouthReportList: (config) =>
    createAPI('customEncryptApiName-1/0qspec0nfncfs0tqd0w20zpvuiSfqpsu0mjtu', 'post', config),
  // 小记者保存
  postYouthReportApply: (config) =>
    createAPI('customEncryptApiName-1/0qspec0nfncfs0tqd0w20zpvuiSfqpsu0tbwf', 'post', config),
  // 小记者通过
  putYouthReportPass: (config) =>
    createAPI('customEncryptApiName-1/0qspec0nfncfs0tqd0w20zpvuiSfqpsu0qbtt', 'put', config),
  // 小记者删除
  putYouthReportDelete: (config) =>
    createAPI('customEncryptApiName-1/0qspec0nfncfs0tqd0w20zpvuiSfqpsu0efmfuf', 'put', config),
  //导出小记者
  putYouthReportList: (config) =>
    createAPI('customEncryptApiName-1/0qspec0nfncfs00tqd0w20zpvuiSfqpsu0fyqpsu', 'post', config),
  // 小记者不通过
  putYouthReportReject: (config) =>
    createAPI('customEncryptApiName-1/0qspec0nfncfs0tqd0w20zpvuiSfqpsu0sfkfdu', 'put', config),
  getOperationAuth: (config) =>
    createAPI('customEncryptApiName-1/0qspec0nfncfs0tqd0w20zpvuiSfqpsu0hfuPqfsbujpoBvui', 'post', config),
  getOperationDetail: (config) =>
    createAPI('customEncryptApiName-1/0qspec0nfncfs0tqd0w20zpvuiSfqpsu0efubjm', 'get', config),
  downloadReportTemplate: (config) =>
    createAPI('customEncryptApiName-1/0qspec0nfncfs0tqd0w20zpvuiSfqpsu0epxompbeUfnqmbuf', 'get', config),
  //投稿配置设置
  postArticleConfig: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ojt0ojt0zpvuiSfqpsufs0tvcnjttjpo0dpogjh', 'post', config),
  //小记者投稿配置查询
  getArticleConfig: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ojt0ojt0zpvuiSfqpsufs0tvcnjttjpo0dpogjh', 'get', config),
  //入驻配置设置
  postReporterConfig: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ojt0ojt0zpvuiSfqpsufs0dpogjh', 'post', config),
  postConvert2Article: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ojt0ojt0zpvuiSfqpsufs0dpowfsu3Bsujdmf', 'post', config),
  //查询入驻配置查询
  getReporterConfig: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ojt0ojt0zpvuiSfqpsufs0dpogjh', 'get', config),
  getSubmissionDetail: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ojt0ojt0zpvuiSfqpsufs0tvcnjttjpo0efubjm', 'get', config),
  postSubmissionModify: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ojt0ojt0zpvuiSfqpsufs0tvcnjttjpo0npejgz', 'post', config),
  downloadFile: (config) =>
    createAPI('customEncryptApiName-1/0qspec0nfncfs0tqd0w20bqq0epxompbeGjmf', 'post', config),
  getOperationLogs: (config) =>
    createAPI('customEncryptApiName-1/0qspec0nfncfs0tqd0w20bqq0hfuPqfsbujpoMpht', 'get', config),
  // 小记者关注列表导出
  postYouthReporterRssExport: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.dpmvno0dpmvnot0zpvuiSfqpsufs0stt0fyqpsu!', 'post', config),
  // 查询栏目列表
  getColumnListByAppStyle: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.dpmvno0dpmvnot0hfuDpmvnoMjtuCzBqqTuzmf', 'get', config),
  //会员手机号解密的接口 还是需要保留，在新建小记者和修改时都需要用到
  getMmberDecryptMobileByUserId: (config) =>
  createAPI('customEncryptApiName-1/0qspec0nfncfs0tqd0w20bqq0hfuEfdszquNpcjmfCzVtfsJe', 'get', config),
  //小记者解密接口，本期后端新增的， 原来的会员手机号解密接口 这里不再适配了
  getDecryptMobileByUserId: (config) =>
    createAPI('customEncryptApiName-1/0qspec0nfncfs0tqd0w20zpvuiSfqpsu0hfuEfdszquNpcjmfCzVtfsJe', 'get', config),
  // 报料-导出
  postYouthReporterExport: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ojt0ojt0zpvuiSfqpsufs0tvcnjttjpo0fyqpsu', 'post', config),
  //小记者榜单设置查询接口
  getYouthReporterSubmissionRankconfig: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ojt0ojt0zpvuiSfqpsufs0tvcnjttjpoSbol0dpogjh', 'get', config),
  //小记者榜单设置保存接口
  postYouthReporterSubmissionRankconfig: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ojt0ojt0zpvuiSfqpsufs0tvcnjttjpoSbol0dpogjh', 'post', config),
  //小记者榜单稿件初始值查询
  getYouthReporterSubmissionHotInitial: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ojt0ojt0zpvuiSfqpsufs0tvcnjttjpoSbol0ipuJojujbm', 'get', config),
  //小记者榜单稿件初始值查询
  postYouthReporterSubmissionHotInitial: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ojt0ojt0zpvuiSfqpsufs0tvcnjttjpoSbol0ipuJojujbm', 'post', config),
  //榜单导出
  postYouthReporterSubmissionRankExport: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ojt0ojt0zpvuiSfqpsufs0tvcnjttjpoSbol0fyqpsu', 'post', config),

  ///榜单增加和移除
  postYouthReporterSubmissionRankProcess: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ojt0ojt0zpvuiSfqpsufs0tvcnjttjpoSbol0qspdftt', 'post', config),


}
